import React from "react";
import { Button, Header, Modal, Table } from "semantic-ui-react";
import useProcessPeriodModal from "@hooks/useProcessPeriodModel";
import useComplianceView from "@hooks/useComplianceView";
import { useSelector } from "react-redux";
import DownloadButton from "../buttons/DownloadButton.js";
import SimpleInputComponent from "../../common/components/shared/forms/SimpleInputComponent.js";

const ProcessPeriodModal = () => {
  const {
    data,
    open,
    toggleProcessPeriodModal,
    onProcessClick,
    onCompleteClick,
  } = useProcessPeriodModal();

  const {
    operator,
    quarter,
    quarter: { startDate, endDate, year },
  } = useComplianceView();

  const {
    filterSelected: { company },
  } = useSelector((state) => state.complianceFilters);

  return (
    <Modal
      open={open}
      onClose={toggleProcessPeriodModal}
      closeIcon
      size="large"
    >
      <Header>Compliance Events - Quarterly Return Processing</Header>
      <Modal.Content>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "3px",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <SimpleInputComponent
            name="startDate"
            label="From:"
            value={startDate}
            className="w-10em"
          />
          <SimpleInputComponent
            name="endDate"
            label="To:"
            value={endDate}
            className="w-10em"
          />
          <SimpleInputComponent
            name="quarter"
            label="Quarter:"
            value={quarter?.quarter}
            className="w-10em"
          />
          <SimpleInputComponent
            name="year"
            label="Year:"
            value={year}
            className="w-10em"
          />
          <SimpleInputComponent
            name="tenantId"
            label="Tenant ID:"
            value={operator}
            className="w-10em"
          />
          <SimpleInputComponent
            name="tenantId"
            label="Person ID:"
            value={0}
            className="w-10em"
          />
          <SimpleInputComponent
            name="company"
            label="Company"
            value={company?.name}
            className="w-10em"
          />
          <SimpleInputComponent
            name="tenantId"
            label="Organisation ID:"
            value={company?.id}
            className="w-10em"
          />
          <DownloadButton
            caption="Setup Return"
            onClick={() => onProcessClick()}
          />
        </div>

        <Table celled basic>
          <Table.Header>
            <Table.Row>
              <Table.Cell>&nbsp;</Table.Cell>
              <Table.Cell colSpan="3" textAlign="center">
                Self Exclusion
              </Table.Cell>
              <Table.Cell>&nbsp;</Table.Cell>
              <Table.Cell colSpan="4" textAlign="center">
                Incidents
              </Table.Cell>
              <Table.Cell></Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell textAlign="center">License Type</Table.Cell>
              <Table.Cell textAlign="center">New</Table.Cell>
              <Table.Cell textAlign="center">Breach</Table.Cell>
              <Table.Cell textAlign="center">RTG</Table.Cell>
              <Table.Cell textAlign="center">Think 25</Table.Cell>
              <Table.Cell textAlign="center">Customer</Table.Cell>
              <Table.Cell textAlign="center">SA</Table.Cell>
              <Table.Cell textAlign="center">EV</Table.Cell>
              <Table.Cell textAlign="center">UGD</Table.Cell>
              <Table.Cell textAlign="center">Customer Interactions</Table.Cell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {data.map((summary) => {
              return (
                <Table.Row>
                  <Table.Cell>{summary.licenceType}</Table.Cell>
                  <Table.Cell textAlign="center">
                    {summary.selfExclusionNewCount}
                  </Table.Cell>
                  <Table.Cell textAlign="center">
                    {summary.selfExclusionBreachCount}
                  </Table.Cell>
                  <Table.Cell textAlign="center">
                    {summary.selfExclusionReturnToGamblingCount}
                  </Table.Cell>
                  <Table.Cell textAlign="center">
                    {summary.ageVerificationCount ?? 0}
                  </Table.Cell>
                  <Table.Cell textAlign="center">
                    {summary.customerIncidentCount ?? 0}
                  </Table.Cell>
                  <Table.Cell textAlign="center">
                    {summary.suspiciousActivityCount ?? 0}
                  </Table.Cell>
                  <Table.Cell textAlign="center">
                    {summary.enforcementVisitCount ?? 0}
                  </Table.Cell>
                  <Table.Cell textAlign="center">
                    {summary.gamblingDisputeCount ?? 0}
                  </Table.Cell>
                  <Table.Cell textAlign="center">
                    {summary.customerInteractionCount ?? 0}
                  </Table.Cell>
                </Table.Row>
              );
            })}
          </Table.Body>
        </Table>
      </Modal.Content>
      <Modal.Actions>
        <Button content="Cancel" onClick={toggleProcessPeriodModal} negative />
        <Button content="Complete" onClick={onCompleteClick} positive />
      </Modal.Actions>
    </Modal>
  );
};

export default ProcessPeriodModal;
